import React, { useEffect, useState } from "react";
import { getBoxTypesInformation } from "../firebase/fireFuncs";
import useHover from "../hooks/useHover";
import Checkbox from "../misc/elements/Checkbox";
import { objectToArray } from "../misc/helperfuncs";

const PickRelatedBoxTypesModal = ({ selectedBoxTypes, onSelected }) => {
  const [boxTypes, setBoxTypes] = useState([]);

  useEffect(() => {
    getBoxTypesInformation((information) => {
      const fireBoxTypes = objectToArray(information.typeNames);
      setBoxTypes(
        fireBoxTypes.map((kv) => {
          return { name: kv.key, used: kv.value };
        })
      );
    });
  }, []);
  return (
    <div
      className="divColumn"
      style={{
        padding: "5px",
        backgroundColor: "#2f2f2f",
        width: "250px",
        borderRadius: ".5rem/.5rem",
      }}
    >
      <div
        className="textBoldWhite"
        style={{ fontSize: "20px", paddingBottom: "5px" }}
      >
        Box Types
      </div>
      <div
        className="divColumn"
        style={{ overflow: "auto", maxHeight: "200px", width: "100%" }}
      >
        {boxTypes.map((boxType, index) => (
          <RelatedHolder
            key={index}
            {...boxType}
            onSelected={onSelected}
            selectedBoxTypes={selectedBoxTypes}
          />
        ))}
      </div>
    </div>
  );
};

const RelatedHolder = ({ name, used, selectedBoxTypes, onSelected }) => {
  const hover = useHover();
  return (
    <div
      onClick={() => onSelected(name)}
      {...hover.divProps}
      className="divRow"
      style={{
        width: "97%",
        padding: "3px",
        borderRadius: ".5rem/.5rem",
        border: "2px solid grey",
        backgroundColor: hover.hover ? "#4f4f4f" : "#2f2f2f",
      }}
    >
      <Checkbox item={name} includeList={selectedBoxTypes} />
      <div
        className="textBold"
        style={{ flex: 1, color: "white", textAlign: "center" }}
      >
        {name}
      </div>
      <img className="icon20" src="/icons/icon_box.png" />
    </div>
  );
};

export default PickRelatedBoxTypesModal;
